import { Route, Routes } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { useAuth } from './auth/useAuth';
import { AppShell } from './components/AppShell';
import { getMe } from './api/client';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { ClientsListPage } from './pages/ClientsListPage';
import { ClientDetailPage } from './pages/ClientDetailPage';
import { CommunityDashboardPage } from './pages/CommunityDashboardPage';
import { AccountPage } from './pages/AccountPage';
import { HomeRedirect } from './pages/HomeRedirect';
import { NotFoundPage } from './pages/NotFoundPage';

function Home() {
  const { getIdToken } = useAuth();
  const me = useQuery({ queryKey: ['me'], queryFn: () => getMe(getIdToken) });
  return <HomeRedirect meAccountType={me.data?.accountType} isLoading={me.isLoading} />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/clients" element={<ClientsListPage />} />
        <Route path="/clients/:memberId" element={<ClientDetailPage />} />
        <Route path="/community" element={<CommunityDashboardPage />} />
        <Route path="/account" element={<AccountPage />} />
      </Route>
      <Route path="/" element={<Home />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
